










































































































































import Vue from 'vue';
import { Cv, CvPublishTypeEnum } from '@/../gen';
import { i18n, i18nHints } from '@/plugins/i18n';

export interface FormDataInterface {
  title?: string;
  publish_type: CvPublishTypeEnum;
  password?: string;
  password_confirmation?: string;
  original_path?: string;
  publish_date?: string;
}

export default Vue.extend({
  props: {
    cv: {
      type: Object as () => Cv,
      required: true,
    },
    isDeletable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        title: this.cv.title,
        publish_type: this.cv.publish_type,
        password: null,
        password_confirmation: null,
        original_path: this.cv.original_path,
        publish_date: this.cv.publish_date,
      } as FormDataInterface,
    };
  },
  computed: {
    publishTypeRadios: () => {
      const makeRadio = publishType => {
        return {
          value: publishType,
          text: {
            type: i18n.tc(i18nHints.models.cv.publish_type[publishType]),
            subTitle: i18n.tc(
              i18nHints.models.cv.publish_type_details[publishType].sub_title
            ),
            description: i18n.tc(
              i18nHints.models.cv.publish_type_details[publishType].description
            ),
          },
        };
      };
      return [
        makeRadio(CvPublishTypeEnum.Open),
        makeRadio(CvPublishTypeEnum.OpenUnlisted),
        makeRadio(CvPublishTypeEnum.OpenWithPw),
        makeRadio(CvPublishTypeEnum.Secret),
      ];
    },
    isOpenWithPw() {
      return this.formData.publish_type === CvPublishTypeEnum.OpenWithPw;
    },
    isSetPw() {
      return (
        this.formData.publish_type === CvPublishTypeEnum.OpenWithPw &&
        this.cv.password !== null
      );
    },
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.formData);
    },
    onCancel() {
      this.$emit('cancel');
    },
    onDelete() {
      this.$emit('delete');
    },
  },
});
